import { PortalDsBadge } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';
import type { CampaignStatus } from '../types/campaigns.types';
import { getCampaignStatusLabel } from '../utils/campaign-status.utils';

const STATUS_BADGE_CLASS: Record<CampaignStatus, string> = {
  new: 'border border-[#6028B4]/20 bg-[#6028B4]/10 text-[#6028B4]',
  in_progress: 'border border-[#2563EB]/20 bg-[#2563EB]/10 text-[#2563EB]',
  complete: 'border border-[#059669]/20 bg-[#059669]/10 text-[#059669]',
  closed: 'border border-[#9CA3AF]/30 bg-[#F3F4F6] text-[#5E6278]',
};

interface CampaignStatusBadgeProps {
  status: CampaignStatus;
  className?: string;
}

export function CampaignStatusBadge({ status, className }: CampaignStatusBadgeProps) {
  return (
    <PortalDsBadge
      pill
      className={cn('w-fit', STATUS_BADGE_CLASS[status], className)}
    >
      {getCampaignStatusLabel(status)}
    </PortalDsBadge>
  );
}
